import Movimentacao from "@/Pages/Caixas/movimentacao.vue";
import temPermissao from "./guards/temPermissao";

export default [
  {
    path: "/movimentacoes",
    name: "movimentacao",
    component: Movimentacao,
    beforeEnter: (to, from, next) => {
      if (!temPermissao("caixas.abrir", to, from, next)) return;
      next();
    },
  },
];
